import { Wrapper } from './DatePickerStyled';
import { DatePickerBase } from 'components/DatePicker';
import { ReactDatePickerProps } from 'react-datepicker';

function DatePicker(props: ReactDatePickerProps) {
  return (
    <Wrapper>
      <DatePickerBase {...props} />
    </Wrapper>
  );
}

export default DatePicker;
